import { render } from "./ReceivingPackage.vue?vue&type=template&id=8a993774&ts=true"
import script from "./ReceivingPackage.vue?vue&type=script&lang=ts"
export * from "./ReceivingPackage.vue?vue&type=script&lang=ts"

import "./ReceivingPackage.vue?vue&type=style&index=0&id=8a993774&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__